import api from 'Application/api/api';

const getEpcPartners = (signal, configuration, filters = {}, searchQuery) => {
	const { page = 1, itemsPerPage = 20, sortBy = 'name', sortDirection = 'ASC' } = configuration;

	const params = {
		...filters,
		...configuration,
		query: searchQuery,
	};

	if (page) {
		params.page = page - 1;
	}

	if (itemsPerPage) {
		params.size = itemsPerPage;
	}

	if (sortBy && sortDirection) {
		params.sort = `${sortBy},${sortDirection}`;
	}

	return api.get('/epcpartners/get-pageable', {
		params,
		signal,
	});
};

export default getEpcPartners;
